<template>
  <div
    :class="fieldClass"
    class="field field--text"
  >
    <label
      v-if="hasLabel"
      :for="name"
    >
      {{ label }}
    </label>
    <div
      :class="fieldInputClass"
      class="field__input"
    >
      <div
        v-if="hasIconLeft"
        class="field__icon-left"
      >
        <slot name="iconLeft" />
      </div>
      <input
        ref="input"
        :value="value"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        :id="name"
        :type="computedType"
        :maxlength="maxLength"
        :autocomplete="autocomplete"
        :min="min"
        :max="max"
        @input="updateValue"
        @focus="handleFocus"
        @blur="formInputHandleBlur"
      >
    </div>
    <div
      v-show="showError"
      class="field__error"
    >
      {{ errorMsg }}
    </div>
    <div
      v-show="showRequiredError"
      class="field__error"
    >
      This field is required.
    </div>
  </div>
</template>

<script>
import FormInputMixin from '../../mixins/forms/FormInputMixin'

export default {
  name: 'TextInput',
  mixins: [
    FormInputMixin,
  ],
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 10000
    },
    autocomplete: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    pattern: {
      type: String,
      default: null
    },
  },
  computed: {
    hasIconLeft () {
      return this.$slots['iconLeft']
    },
    fieldInputClass () {
      return {
        'field__input--icon-left': this.hasIconLeft
      }
    },
    computedType () {
      if (this.type === 'number') {
        return 'text'
      }
      return this.type
    }
  },
  watch: {
    value () {
      this.setInputValue()
    }
  },
  methods: {
    setInputValue () {
      const { input } = this.$refs
      if (this.value !== input.value) {
        input.value = this.value
      }
    },
    updateValue (event) {
      const char = event.data
      let value = event.target.value
      if (this.pattern && char) {
        // Test against the regex pattern provided by `pattern` prop, if not
        // matches, return to previous value
        if (!new RegExp(this.pattern).test(char)) {
          value = this.value
        }
      } else if (this.type === 'number' && char) {
        // Test if entered char is not numeric return to previous value
        if (/\D/.test(char)) {
          value = this.value
        }
      } else if (this.type === 'float' && char) {
        // Test if entered char is not float (numbers and dots), if it's not
        // return to previous value
        if (/[^\d.]/.test(char)) {
          value = this.value
        }
      }
      if (value !== event.target.value) {
        event.target.value = value
      }
      this.$emit('input', value)
    },
    formInputHandleBlur (e) {
      this.handleBlur()
      this.$emit('blur', e)
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.setInputValue()
    })
  },
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

input
  background-clip: padding-box
  background-color: $input-bg-color
  border-color: $input-border-color
  border-radius: 1.5px
  border-style: solid
  border-width: 1px
  box-sizing: border-box
  box-shadow: inset 0 2px 1px rgba(0, 0, 0, 0.025)
  color: $input-text-color
  font-family: inherit
  font-size: 13px
  font-weight: 400
  line-height: 38px
  height: 38px
  outline: none
  padding: 0 11px
  text-shadow: none
  width: 100%
  letter-spacing: 0.35px

  @include desktop
    padding-left: 15px
    padding-right: 15px

  &.input--open
    background-color: transparent
    border-bottom: 0.5px solid $input-border-color
    border-left: 0
    border-radius: 0
    border-right: 0
    border-top: 0
    height: auto
    padding: 0 0 5px 0

  &[disabled]
    opacity: 0.5

  &:focus
    border-color: $input-border-color-focus

  &::placeholder
    color: $input-text-placeholder-color

.field--error
  input
    border-color: rgba($input-error-color, .3)

    &::-webkit-input-placeholder,
    &:-moz-placeholder,
    &::-moz-placeholder,
    &:-ms-input-placeholder
      color: $input-error-color
</style>



// WEBPACK FOOTER //
// src/components/forms/TextInput.vue